var _defs, _style, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 16,
    height: 16,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAAXNSR0IB2cksfwAAAOpQTFRFAj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+ez6jGwAAAE50Uk5T3/L68dMATe/1+JX2vuhT/9rJorvL61JYEaHNuYmbVL3MCBAyH/nFHeoJBhQM++5P/Zmfq62Wz7pVYI6Yhmcn/Mcj1GMhxiB+SFeooI0zJasusAAAAM5JREFUeJxNzt1SwjAQBeAl9tgWokGlYBCVH7EoILREUNFqRQqCvP/ruMReeG525pvs5hAVhBAHDg5dTwjfLVKpIKUsHeFYlaU8UackzgBUAlRVDThXmoRkqO/hotG4/AdXyoZXrhmaQavdsbmh7m0Yhk7v7r5vM6ChffmAkTfm6UUUT4wxk0e+MTVmxjeQ50k9AyH/8jKPomj+ysXegITh3d5wuUcO/keapp89hgXwxdBdZlnm7GGVJGuGcb7y/dd0Q8Wt1nr7g13MU8eLX/4EGb1z6oXyAAAAAElFTkSuQmCC"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    x: 0,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashIcon);
export default __webpack_public_path__ + "static/media/dashIcon.a0decccad6755805897aa48cb4cb1aea.svg";
export { ForwardRef as ReactComponent };